module.exports = __webpack_public_path__ + "img/notice2025-detail.0293a289.jpg";